<template>
  <vue-dropzone
    ref="ocr-uploader"
    id="ocr-uploader"
    :options="uploaderOptions"
    :useCustomSlot="true"
    @vdropzone-file-added="onFileAdded"
    @vdropzone-files-added="onFilesAdded"
  >
    <div class="dropzone-custom-content">
      <div class="content-title">読み取るファイルを選んでください</div>
      <div class="content-icon">
        <svg width="40" height="49" viewBox="0 0 40 49" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M38 10.3118V47H2V2H30.7237" fill="white"/>
          <path d="M38 10.3118V47H2V2H30.7237" stroke="#7B7B7B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M39.5 11.5H30V1" fill="#7B7B7B"/>
        </svg>
      </div>
      <div class="content-subtitle">※このスペースに読み取りたいファイルやフォルダをドラッグしてもOK！</div>
    </div>
  </vue-dropzone>
</template>

<script type="text/javascript">
  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';

  export default {
    props: {
      options: {}
    },
    data: function () {
      return {
        uploaderOptions:{
          url: 'http://localhost',
          uploadMultiple: true,
          autoProcessQueue: false
        }
      };
    },
    components: {
      vueDropzone: vue2Dropzone
    },
    methods: {
      onFileAdded (file) {
        this.$emit('on-file-added', file)
      },
      onFilesAdded (files) {
        this.$emit('on-files-added', files)
      },
      reset () {
        this.$refs['ocr-uploader'].removeAllFiles();
      }
    },
    watch: {
      options: {
        deep: true,
        handler (newValue) {
          for (let i in newValue) {
            this.$set(this.uploaderOptions, i, newValue[i]);
          }
        }
      }
    },

  }
</script>

<style scoped>
  .vue-dropzone {
    border: 2px dashed #7B7B7B !important;
    padding: 37px 20px 28px;
    overflow: auto;
    height: auto;
  }

  ::v-deep .dz-message {
    margin: 0 !important;
  }

  ::v-deep .dz-error-message, ::v-deep .dz-error-mark {
    display: none !important;
  }

  .dropzone-custom-content {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }

  .dropzone-custom-content .content-title {
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0.04em;
    color: #141414;
    margin-bottom: 8.87px;
  }
  .dropzone-custom-content .content-icon {
    margin-bottom: 8px;
  }
  .dropzone-custom-content .content-subtitle {
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.04em;
    color: #141414;
    font-weight: 400;
  }

@media only screen and (max-width: 768px) {
  .dropzone-custom-content .content-title {
    font-size: 14px;
    font-weight: bold;
  }
  .vue-dropzone {
    padding: 16px 24px;
  }
}
</style> 